// utils/handleDragEnd.js
export const handleDragEndFactory = (fields, move, getValues, setValue) => {
  return (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const oldIndex = fields.findIndex((f) => f.id === active.id);
    const newIndex = fields.findIndex((f) => f.id === over.id);

    if (oldIndex === -1 || newIndex === -1 || oldIndex === newIndex) return;

    // Reorder using RHF move function
    move(oldIndex, newIndex);

    // Update the `order` attribute for all fields
    const updatedFields = getValues("sections").map((section, idx) => ({
      ...section,
      order: idx + 1, // assign new order based on array index
    }));

    updatedFields.forEach((section, idx) => {
      setValue(`sections.${idx}`, section, { shouldValidate: true });
    });
  };
};

export const getAllNavigationLabels = (navigations) => {
  const result = [];

  const flatten = (items) => {
    if (!Array.isArray(items)) return;
    
    items.forEach((item) => {
      if (item?.label) {
        result.push({
          label: item.label,
          navigationId: item.navigationId,
          type: item.type,
        });
      }

      // Recursively check children
      if (item?.children && Array.isArray(item.children) && item.children.length > 0) {
        flatten(item.children);
      }
    });
  };

  flatten(navigations);
  return result;
};

export const isDuplicateNameInNavigations = (name, navigations, excludeId = null) => {
  if (!name || !navigations || !Array.isArray(navigations)) return false;

  const normalizedName = name.toLowerCase().trim();
  const allLabels = getAllNavigationLabels(navigations);
  return allLabels.some((item) => {
    const normalizedLabel = item.label?.toLowerCase().trim();
    const isExcluded = excludeId && item.navigationId && Number(item.navigationId) === Number(excludeId);
    return !isExcluded && normalizedLabel === normalizedName;
  });
};

export const isDuplicatePageTitle = (title, existingPages, id) => {
  if (!title) return false;

  const normalizedTitle = title.toLowerCase().trim();

  return existingPages.some((page) => {
    const normalizedPageName = page.name?.toLowerCase().trim();

    const isSamePage = page.pageId
      ? Number(page.pageId) === Number(id)
      : page.id && Number(page.id) === Number(id);

    return !isSamePage && normalizedPageName === normalizedTitle;
  });
};

export const stremaLineUrl = (navItems) => {
  const result = [];

  const flatten = (items) => {
    for (const item of items) {
      const { children, navigationType, ...rest } = item;

      if (navigationType !== "INTERNAL_GROUP") {
        result.push(rest);
      }

      if (children && children.length > 0) {
        flatten(children); // always traverse children
      }
    }
  };

  flatten(navItems);
  return result;
};
